import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

import { af, bareButtonCss, compactQuery, floatingSurfaceCss, hoverQuery } from '../theme';

const styles = {
  /**
   * One card holding every row, with hairlines between them — not a card each.
   *
   * The options are one list of ways to change the same thing, and separate floating cards
   * would read as separate subjects.
   */
  group: css`
    ${floatingSurfaceCss};
    display: flex;
    flex-direction: column;
    overflow: hidden;
  `,

  row: css`
    ${bareButtonCss};
    display: flex;
    align-items: center;
    gap: ${af.sp4};
    width: 100%;
    padding: ${af.sp4} ${af.sp5};
    text-align: left;
    transition: background 0.12s ease;

    ${compactQuery} {
      gap: ${af.sp3};
      padding: ${af.sp3} ${af.sp4};
    }

    /* Inside one surface, so rows separate with a hairline rather than a gap. */
    & + & {
      border-top: 1px solid ${af.lineSoft};
    }

    /* Pointer devices only: on touch the state would stick to the tapped row. */
    ${hoverQuery} {
      &:hover:not(:disabled) {
        background: ${af.fill};
      }
    }

    &:disabled {
      cursor: default;
      opacity: 0.5;
    }
  `,

  icon: css`
    display: flex;
    flex: 0 0 22px;
    align-items: center;
    color: ${af.ink};
  `,

  /** Takes the slack so the chevron stays pinned right however long the text runs. */
  text: css`
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  `,

  chevron: css`
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    color: ${af.muted};
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
